/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileNwd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zm-6.111 2H19v15h-3.578s-4.822-6.75-6.028-6.675c-.622.037-.505 5.925-.505 5.925l-.778.75H5v-15h3.344l5.834 7.313s.35.487.66.412.273-.787.273-.787V5.25z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileNwd as FillFileNwd };
